export default "__VITE_ASSET__BBQDEctH__"